import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";


class EncumenKararlariAPI extends BaseAPI {
    constructor() {
        const baseUrl = environment.API_URL + "EncumenKararlariListe";
        super(baseUrl);
    }
    getEncumenKararlariListe(ilkTarih: string, sonTarih: string, kararNo: string, Icerik: string) {
        return this.get("", { params: { ilkTarih: ilkTarih, sonTarih: sonTarih, kararNo: kararNo, Icerik: Icerik } });
    }
}
export default new EncumenKararlariAPI();
